import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import { useCart } from './CartContext';
import './rice.css';

const products = [
  { name: 'Fennel Seeds', image: '/images/masala/fennel.webp', link: '/masala/fennalseeds' },
  { name: 'Cumin Seeds', image: '/images/masala/cumin.webp', link: '/masala/cuminseeds' },
  { name: 'Fennel Powder', image: '/images/masala/fennalpowder.webp', link: '/masala/fennalpowder' },
  { name: 'Cumin Powder', image: '/images/masala/cuminpowder.webp', link: '/masala/cuminpowder' },
  { name: 'Pepper Whole', image: '/images/masala/pepper.webp', link: '/masala/pepperwhole' },
  { name: 'Pepper Powder', image: '/images/masala/pepperpowder.webp', link: '/masala/pepperpowder' },
  { name: 'Fenugreek', image: '/images/masala/fenugreek.webp', link: '/masala/fenugreek' },
  { name: 'Mustard', image: '/images/masala/mustard.webp', link: '/masala/mustard' },
  { name: 'Idli Chilli Powder', image: '/images/masala/idlipowder.webp', link: '/masala/idlichillipowder' },
  { name: 'Paruppu Podi', image: '/images/masala/lenttil.webp', link: '/masala/paruppupodi' },
  { name: 'Fish Curry Powder', image: '/images/masala/fishcurry.webp', link: '/masala/fishcurrypowder' },
  { name: 'Fish Fry Masala', image: '/images/masala/fishfry.webp', link: '/masala/fishfrymasala' },
  { name: 'Chicken Masala', image: '/images/masala/chicken.webp', link: '/masala/chickenmasala' },
  { name: 'Mutton Masala', image: '/images/masala/mutton.webp', link: '/masala/muttonmasala' },
  { name: 'Dry Ginger Powder', image: '/images/masala/gingerpowder.webp', link: '/masala/drygingerpowder' },
  { name: 'Garlic Powder', image: '/images/masala/garlicpowder.webp', link: '/masala/garlicpowder' },
  { name: 'Kashmir Chilli Powder', image: '/images/masala/kashmirchillipow.webp', link: '/masala/kashmirchillipowder' },
  { name: 'Sambar Powder', image: '/images/masala/sambar.webp', link: '/masala/sambarpowder' },
  { name: 'Rasam Podi', image: '/images/masala/rasam.webp', link: '/masala/rasampodi' },
  { name: 'Chilli Powder', image: '/images/masala/chillipowder.webp', link: '/masala/chillipowder' },
  { name: 'Turmeric Powder', image: '/images/masala/turmeric.webp', link: '/masala/turmericpowder' },
  { name: 'Coriander Powder', image: '/images/masala/corainderpowder.webp', link: '/masala/corianderpowder' },
];

const qtyOptions = ['100g', '200g', '500g', '1kg'];

const Masala = () => {
  const navigate = useNavigate();
  const { addToCart } = useCart();
  const [selectedQuantities, setSelectedQuantities] = useState({});

  const handleKnowMore = (link) => {
    navigate(link);
  };

  const goToProducts = () => {
    navigate('/products');
  };

  const toggleQtyType = (productIndex, qtyType) => {
    const productQuantities = selectedQuantities[productIndex] || {};
    const isSelected = qtyType in productQuantities;

    const updated = { ...productQuantities };
    if (isSelected) {
      delete updated[qtyType];
    } else {
      updated[qtyType] = 1;
    }

    setSelectedQuantities({
      ...selectedQuantities,
      [productIndex]: updated,
    });
  };

  const incrementQty = (index, qtyType) => {
    const productQuantities = selectedQuantities[index] || {};
    const currentQty = productQuantities[qtyType] || 1;

    setSelectedQuantities({
      ...selectedQuantities,
      [index]: {
        ...productQuantities,
        [qtyType]: currentQty + 1,
      },
    });
  };

  const decrementQty = (index, qtyType) => {
    const productQuantities = selectedQuantities[index] || {};
    const currentQty = productQuantities[qtyType];

    if (currentQty > 1) {
      setSelectedQuantities({
        ...selectedQuantities,
        [index]: {
          ...productQuantities,
          [qtyType]: currentQty - 1,
        },
      });
    }
  };

  const handleAddToCart = (product, index) => {
    const quantities = selectedQuantities[index];
    if (!quantities || Object.keys(quantities).length === 0) {
      toast.warn("Please select at least one quantity!", { position: "top-right" });
      return;
    }

    Object.entries(quantities).forEach(([qtyType, qtyCount]) => {
      const item = {
        ...product,
        qtyType,
        qtyCount,
      };
      addToCart(item);
      toast.success(`${product.name} (${qtyCount} × ${qtyType}) added to cart`, {
        position: "top-right",
        autoClose: 2000,
      });
    });
  };

  return (
    <section className="rice">
      <div className='border'>
        <img src="/images/border.png" className='border-img' alt="decorative border" />
      </div>
      <h1>Jeyam Masala Products</h1>
      <div className='border'>
        <img src="/images/border.png" className='border-img' alt="decorative border" />
      </div>
      <button className='back-btn' onClick={goToProducts}>⟵ Back to Products</button>
      <div className="product-grid">
        {products.map((product, index) => (
          <div className="product-card" key={index}>
            <img src={product.image} alt={product.name} />
            <div className="product-name">{product.name}</div>
            <div className="qty-options">
              {qtyOptions.map((qtyType) => {
                const isSelected = selectedQuantities[index]?.[qtyType];

                return (
                  <div key={qtyType} className="qty-select-block">
                    <span
                      className={isSelected ? 'qty selected' : 'qty'}
                      onClick={() => toggleQtyType(index, qtyType)}
                    >
                      {qtyType}
                    </span>
                    {isSelected && (
                      <div className="qty-controls">
                        <button onClick={() => decrementQty(index, qtyType)}>-</button>
                        <span>{selectedQuantities[index][qtyType]}</span>
                        <button onClick={() => incrementQty(index, qtyType)}>+</button>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>

            <div className="btn-group">
              <button className="know-more" onClick={() => handleKnowMore(product.link)}>
                Know More
              </button>
              <button className="add-cart" onClick={() => handleAddToCart(product, index)}>
                Add to Cart
              </button>
            </div>
          </div>
        ))}
      </div>

      <div className='cart-button'>
        <Link to="/cart">
          <button className='cart-btn'>Go To Cart</button>
        </Link>
      </div>
      <Link to="/cart" className="floating-cart-btn" title="Go to Cart">
        Go to cart 🛒
      </Link>

      <ToastContainer />
    </section>
  );
};

export default Masala;
